<app-layout-default>

  <div class="container">

    <h1 class="c11n-text-2xl-headline margin-bottom-3" [innerHTML]="content.pageTitle"></h1>

    <!-- projected portfolio component -->
      <pbj-projected-portfolio-da [projectionDetails]="DAOpenChoiceAccounts" (daError)="errorHandler($event)"
        (investmentRecsDraftLoaded)="daLoadDraftId($event)" [isMobileView]="true">
      </pbj-projected-portfolio-da>


    <!-- fee estimation component-->
    <div class="margin-top-4">
      <ng-container *ngIf="isMultipleAccountSelection ; else feesEstimationONA">
        <pbj-fees-estimation-da [portfolioType]="'STANDARD'" (daError)="errorHandler($event)"
          (feeModalAnalyticsEvent)="feeModalAnalyticsEventHandler($event)"></pbj-fees-estimation-da>
      </ng-container>
      <ng-template #feesEstimationONA>
        <pbj-fees-estimation-ona [accountBalance]="accountBalance" (daError)="errorHandler($event)"
          (feeModalAnalyticsEvent)="feeModalAnalyticsEventHandler($event)"></pbj-fees-estimation-ona>
      </ng-template>
    </div>

    <!-- pbj common disclaimer -->
    <div class="margin-top-4">
      <pbj-common-disclaimer-ona
        (daError)="errorHandler($event)"></pbj-common-disclaimer-ona>
    </div>

    <section class="margin-top-4">
      <c11n-button id="openChoiceDaEnrollBTN" [labelText]="content.continueButton" [fullWidth]="true"
        (clickEvent)="nextPage()"></c11n-button>
      <app-cancel [quitButtonVariant]="'ghost'" [isOpenChoice]="true"></app-cancel>
    </section>
    <div class="c11n-text-sm disclaimers-wrapper">
      <span [innerHTML]="content.disclaimer.part1"></span>
      <span [innerHTML]="content.disclaimer.part2"></span>
      <a c11n-link [variant]="'secondary-reinforced'" [fontWeight]="'normal'"
      [href]="content.disclaimer.linkHref">{{ content.disclaimer.linkText }}</a>
      <span [innerHTML]="content.disclaimer.part3"></span>
    </div>
    <div class="c11n-text-sm disclaimers-wrapper">
      <span [innerHTML]="commonContent.disclaimer.part1"></span>
      <span [innerHTML]="commonContent.disclaimer.part2"></span>
      <a c11n-link [variant]="'secondary-reinforced'" [fontWeight]="'normal'"
        [href]="commonContent.disclaimer.linkHref">{{ commonContent.disclaimer.linkText }}</a>
      <span [innerHTML]="commonContent.disclaimer.part3"></span>
    </div>
  </div>
  <vgim-secure-link></vgim-secure-link>
</app-layout-default>